import { i18n } from '@/plugins/i18n'
import { subcategories } from '@/constants/subcategories'
import { gatewayStatusStr, gatewayVariant } from '@/constants/gatewayStatus'
import LogoColumn from "../components/logo-column.vue";

const logoTemplate = (row, index, datatable) => {
    let template = new LogoColumn({
        props: {
            row,
            index,
            datatable,
        },
        i18n,
    })

    template.row = row
    template.index = index
    template.datatable = datatable

    return template.$mount().$el
}

export default [
    {
        field: 'id',
        title: '#',
        sortable: true,
        width: 70,
        type: 'number',
        selector: false,//{class: 'kt-checkbox--solid'},
        textAlign: 'center',
    },
    {
        field: 'farsi_name',
        title: i18n.t('label.gateway_title'),
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'psp',
        title: i18n.t('label.psp'),
        template: (row, index, datatable) => {
            return logoTemplate(row, index, datatable)
        },
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'website_address',
        title: i18n.t('label.site_address'),
        sortable: false,
        template: (row) => '<span dir="ltr">'+row.website_address+'</span>',
        width: 120,
        textAlign: 'center',
    },
    {
        field: 'status',
        sortable: true,
        title: i18n.t('label.status'),
        template: (row) => {
            let status  = gatewayStatusStr.get(row.status)
            let variant = 'badge-'+gatewayVariant(row.status)

            return '<div class="badge '+variant+' text-white">'+ status+'</div>'
        },
        width: 120,
        textAlign: 'center',
    }
]